module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('HeaderBar'), _vm._v(" "), _c('OpenPositions'), _vm._v(" "), _c('FooterBar')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a0f0ca8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/OpenPositions.vue
// module id = 472
// module chunks = 0